<template>
  <RevIllustration
    :alt="image.alt"
    class="rounded-lg block object-contain"
    :class="BIG_ITEM_SIZE_CLASS"
    :height="480"
    :sizes="MAIN_IMG_SIZES"
    :src="image.src"
    :width="480"
  />
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'
import { watchDebounced } from '@vueuse/core'

import { useEmitOnce } from '~/scopes/product/composables/useEmitOnce'

import { BIG_ITEM_SIZE_CLASS, MAIN_IMG_SIZES } from '../GalleryNew.constants'
import type { GalleryImage } from '../GalleryNew.types'

const props = defineProps<{
  index: number
  image: GalleryImage
  activeIndex: number
  // Only used for tracking and for resetting the active index, not for layout
  isMobile: boolean
}>()

const emit = defineEmits<{
  (e: 'visible', index: number): void
}>()

const { emitOnce } = useEmitOnce(emit)

const stopWatch = watchDebounced(
  () => props.activeIndex,
  () => {
    if (props.isMobile) {
      stopWatch()

      return
    }

    if (props.index !== 0 && props.index === props.activeIndex) {
      emitOnce('visible', props.index)
    }
  },
  { debounce: 1000, immediate: true },
)
</script>
